import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";

import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";
import * as BonusCardService from "@/services/bonusCard.service";
import { BonusCardStatus } from "@/utils/enums";

import { $CustomerModuleName } from "./customer.types";

const { isLoading, isSuccessfullyLoaded } =
    generateDefaultSelectors($CustomerModuleName);

const getState = (state: IState) =>
    getApiDataState(state, $CustomerModuleName)?.data;

const getCustomer = (state: IState) => {
    return getState(state);
};

const getBonusCardStatus = (state: IState) => {
    const customerState = getState(state);

    return customerState
        ? BonusCardService.getStatus(customerState)
        : BonusCardStatus.NoCard;
};

const isCustomerFilledIn = (state: IState) => {
    const customer = getCustomer(state);
    return (
        customer?.firstName &&
        customer?.lastName &&
        customer?.phone &&
        (customer?.customerType === ComponentsCustomerType.B2B
            ? customer?.vatNr && customer?.companyName
            : true)
    );
};

export {
    getBonusCardStatus,
    getCustomer,
    isCustomerFilledIn,
    isLoading,
    isSuccessfullyLoaded
};
